import { post } from '../../lib/api';
import { describeError } from '../../components/toast';

/**
 * Takes tickets back out of the trash, one request each.
 *
 * There is no bulk restore endpoint; restoring is checked per ticket against
 * the same permission as deleting it, so a batch can partly succeed and is
 * reported that way. A few requests run at once — enough to undo a page of
 * deletions quickly without flooding the server.
 */
export async function restoreTickets(
  numbers: number[],
): Promise<{ restored: number[]; failed: Array<{ number: number; reason: string }> }> {
  const queue = [...numbers];
  const restored: number[] = [];
  const failed: Array<{ number: number; reason: string }> = [];

  const worker = async () => {
    for (let number = queue.shift(); number !== undefined; number = queue.shift()) {
      try {
        await post(`/tickets/${number}/restore`);
        restored.push(number);
      } catch (error) {
        failed.push({ number, reason: describeError(error).title });
      }
    }
  };

  await Promise.all(Array.from({ length: Math.min(4, numbers.length) }, worker));
  return { restored, failed };
}
